// useFollows — the star's server state (the follows module: one table, one
// verb per followable kind — ADR-073 §6). Follow ⊥ everything: it grants
// nothing and audits nothing; a toggle invalidates the followed kind's prefix
// so every list and peek showing the star refetches together.

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { FollowState } from '@ems-app/schemas/tickets/responses';
import { apiClient } from '../lib/apiClient.js';
import { sitesKeys } from './useSites.js';
import { ticketsKeys } from './useTickets.js';
import { refreshOnSettled } from '../lib/settled.js';

export function useFollowTicket(projectId: string): UseMutationResult<FollowState, Error, { ticketId: string; followed: boolean }> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ticketId, followed }) =>
      (followed ? apiClient.put<FollowState>(`/projects/${projectId}/tickets/${ticketId}/follow`) : apiClient.delete<FollowState>(`/projects/${projectId}/tickets/${ticketId}/follow`)).then((r) => r.data),
    onSettled: refreshOnSettled(() => qc.invalidateQueries({ queryKey: ticketsKeys.all(projectId) })),
  });
}

export function useFollowSite(projectId: string): UseMutationResult<FollowState, Error, { siteId: string; followed: boolean }> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ siteId, followed }) =>
      (followed ? apiClient.put<FollowState>(`/projects/${projectId}/sites/${siteId}/follow`) : apiClient.delete<FollowState>(`/projects/${projectId}/sites/${siteId}/follow`)).then((r) => r.data),
    onSettled: refreshOnSettled(() => qc.invalidateQueries({ queryKey: sitesKeys.all(projectId) })),
  });
}
